import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  // Obtén el color inicial desde localStorage o usa el color por defecto
  const [themeColor, setThemeColor] = useState(() => {
    return localStorage.getItem('themeColor') || '#0062b9'; // Azul principal por defecto
  });

  // Aplica el color inicial al cargar el contexto
  useEffect(() => {
    document.documentElement.style.setProperty('--themeClrPrimary', themeColor);

    // Convierte el color HEX a RGB y actualiza la variable CSS
    const [r, g, b] = themeColor.match(/\w\w/g).map((hex) => parseInt(hex, 16));
    document.documentElement.style.setProperty('--themeClrPrimary-rgb', `${r}, ${g}, ${b}`);
  }, [themeColor]);

  // Cambia el color del tema y actualiza localStorage
  const changeThemeColor = (color) => {
    setThemeColor(color);
    localStorage.setItem('themeColor', color);
    document.documentElement.style.setProperty('--themeClrPrimary', color);

    // Convierte el color HEX a RGB y actualiza la variable CSS
    const [r, g, b] = color.match(/\w\w/g).map((hex) => parseInt(hex, 16));
    document.documentElement.style.setProperty('--themeClrPrimary-rgb', `${r}, ${g}, ${b}`);
  };

  return (
    <ThemeContext.Provider value={{ themeColor, changeThemeColor }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;